import styled from '@emotion/styled';
import {Dropdown} from '@bosch/react-frok';

export const DropdownInput = styled(Dropdown)`
    max-width: 48.6%;
    min-width: 340px;
    margin-right: 1rem;
`;
